<template>
  <base-container :isLoading="isLoading">
    <div class="artisan-base">
      <!-- <van-nav-bar title="用户注册"></van-nav-bar> -->
      <h2 class="artisan-center">欢迎登录</h2>
      <van-form @submit="onSubmit" :show-error-message="false" style="margin-top: 16px;">
        <van-field
          style="border-radius:999px;padding-bottom:5px;"
          v-model="userName"
          label-width="2rem"
          label="用户名"
          placeholder="手机号"
          :rules="[{ required: true, message: '请填写手机号' }]"
        >
          <template #label>
            <van-image
              style="margin:3px 5px"
              width="17"
              height="17"
              :src="require('@/assets/img/user.png')"
            />
          </template>
        </van-field>
        <van-field
          style="border-radius:999px;margin-top:12px;padding-bottom:5px;"
          v-model="userPwd"
          label-width="2rem"
          type="password"
          label="密码"
          placeholder="密码"
          :rules="[{ required: true, message: '请填写密码' }]"
        >
          <template #label>
            <van-image
              style="margin:3px 5px"
              width="17"
              height="17"
              :src="require('@/assets/img/lock.png')"
            />
          </template>
        </van-field>
        <div style="margin-top: 16px;">
          <van-button class="artisan-btn" round block type="info" native-type="submit">登录</van-button>
        </div>
      </van-form>
      <van-row style="margin:12px 7px;font-size:1rem;">
        <van-col span="8" style="text-align:center">
          <router-link style="color: #c71d24;" to="/forgetpwd">忘记密码？</router-link>
        </van-col>
        <van-col span="8" offset="8" style="text-align:center">
          <router-link style="color: #c71d24;" to="/register">注册</router-link>
        </van-col>
      </van-row>
      <!-- <van-button
      class="artisan-btn"
      size="normal"
      type="info"
      v-if="isYunLogin"
      round
      block
      @click="loginFormYun"
      >长江云登录</van-button>-->
    </div>
  </base-container>
</template>
<script>
import { login, loginByYun } from "@/api/auth";
import { setToken, setRefreshToken } from "@/util/auth";
// import { Toast } from "vant";
export default {
  data() {
    return {
      isLoading: false,
      isYunLogin: false,
      userName: "",
      userPwd: "",
      yunid: "",
    };
  },
  watch: {
    yunid(newVal) {
      if (newVal) {
        this.login(newVal);
      }
    },
  },
  created() {
    if (window.mc) {
      this.isYunLogin = true;
      this.loginFormYun();
    }
  },
  methods: {
    forgetPwd() {
      this.$router.push("/forget");
    },
    toRegister() {
      this.$router.push("/register");
    },
    onSubmit() {
      this.isLoading = true;
      login(this.userName, this.userPwd)
        .then((res) => {
          this.loginSuccess(res);
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    loginSuccess(res) {
      setToken(res.data.value.token);
      setRefreshToken(res.data.value.refreshToken);
      var redirect = this.$store.getters.getLoginRedirect;
      console.log(redirect);
      if (redirect) {
        this.$router.push(redirect);
      } else {
        this.$router.push("/");
      }
    },
    login(yunid) {
      this.isLoading = true;
      loginByYun(yunid)
        .then((res) => {
          this.isLoading = false;
          this.loginSuccess(res);
        })
        .catch((err) => {
          this.isLoading = false;
          alert(err);
        });
    },
    loginFormYun() {
      if (this.isYunLogin) {
        if (this.yunid) {
          this.login(this.yunid);
        } else {
          let $this = this;
          window.mc.userGetInfo(function (data) {
            if (data.state) {
              $this.yunid = data.data.id;
            }
          });
        }
      }
    },
  },
};
</script>
<style>
</style>